import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import SmartSuggestionBanner from './SmartSuggestionBanner';
import WhatsNewModal from '../onboarding/WhatsNewModal';
import { Toaster } from 'sonner';
import { useApplyDefaultView } from '../../hooks/useApplyDefaultView';

const MainLayout = () => {
  // Auto-apply each user's pinned default view on entering a list page
  useApplyDefaultView();

  return (
    <div className="min-h-screen bg-background">
      {/* Accessibility — skip to content */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:px-3 focus:py-2 focus:bg-[#111565] focus:text-white focus:rounded"
        data-testid="skip-to-content"
      >
        Skip to main content
      </a>
      <Sidebar />
      <TopBar />
      
      {/* Main Content */}
      <main id="main-content" className="lg:ml-64 min-h-screen safe-area-bottom" tabIndex="-1">
        <div className="p-4 md:p-6 lg:p-8 pt-16 lg:pt-16">
          <Outlet />
        </div>
      </main>

      <SmartSuggestionBanner />
      <WhatsNewModal />

      <Toaster 
        position="top-right" 
        richColors 
        closeButton
        toastOptions={{
          style: {
            fontFamily: 'Inter, sans-serif',
          },
        }}
      />
    </div>
  );
};

export default MainLayout;
